import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Icon from '../containers/icon';
const SaveButton = _ref => {
  let _ref$saveState = _ref.saveState,
    saveState = _ref$saveState === void 0 ? SaveButton.STATUS_DISABLED : _ref$saveState,
    onSave = _ref.onSave;
  /* three possible conditions:
   *    pending:  this means there are changes pending.
   *           conditions:
   *             not disabled and changes pending.
   *    inProgress:  this means we are currently saving the object.
   *           conditions:
   *             changes pending, save disabled.
   *
   *    disabled:  this means there are no pending changes.
   *            conditions:  everything else!
   */
  const _SaveButton$status$sa = SaveButton.status[saveState],
    glyph = _SaveButton$status$sa.glyph,
    text = _SaveButton$status$sa.text,
    className = _SaveButton$status$sa.className;
  return /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    size: "sm",
    color: "primary",
    className: "float-md-right ".concat(className),
    onClick: onSave,
    disabled: saveState !== SaveButton.STATUS_PENDING
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    glyph: glyph,
    style: {
      marginRight: '5px'
    }
  }), text));
};
SaveButton.STATUS_PENDING = 'pending';
SaveButton.STATUS_IN_PROGRESS = 'inProgress';
SaveButton.STATUS_DISABLED = 'disabled';
SaveButton.status = {
  [SaveButton.STATUS_PENDING]: {
    text: 'Save',
    glyph: 'arrow-circle-down',
    className: 't-button-save'
  },
  [SaveButton.STATUS_IN_PROGRESS]: {
    text: 'Wait',
    glyph: 'hourglass',
    className: 't-button-save-progress'
  },
  [SaveButton.STATUS_DISABLED]: {
    text: 'Saved',
    glyph: 'check-circle',
    className: 't-button-save-disabled'
  }
};
SaveButton.propTypes = {
  saveState: PropTypes.oneOf([SaveButton.STATUS_PENDING, SaveButton.STATUS_IN_PROGRESS, SaveButton.STATUS_DISABLED]),
  onSave: PropTypes.func.isRequired
};
export default SaveButton;